import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetBookingFees_Booking$key } from "./__generated__/useGetBookingFees_Booking.graphql";

export const useGetBookingFees = ({
  bookingFragmentRef,
}: {
  bookingFragmentRef: useGetBookingFees_Booking$key | null;
}) => {
  const data = useFragment(useGetBookingFeesFragmentString, bookingFragmentRef);

  return {
    bookingFees:
      data?.orders?.edges?.flatMap(
        (order) =>
          order?.node?.serviceCharges?.edges?.map(
            (serviceCharge) => serviceCharge?.node
          ) || []
      ) || [],
    bookingFeesTotal:
      data?.orders?.edges?.reduce((acc: number, order) => {
        const serviceChargeTotal =
          order?.node?.serviceCharges?.edges?.reduce(
            (total, serviceCharge) =>
              total + (serviceCharge?.node?.amount ?? 0),
            0
          ) ?? 0;
        return acc + serviceChargeTotal;
      }, 0) ?? 0,
  };
};

export const useGetBookingFeesFragmentString = graphql`
  fragment useGetBookingFees_Booking on Booking {
    orders {
      edges {
        node {
          serviceCharges {
            edges {
              node {
                amount
                name
              }
            }
          }
        }
      }
    }
  }
`;
